import { useMutation } from "@tanstack/react-query";
import { downloadLoaderAPI } from "./downloadLoader.api";
import { handleNetworkError } from "@repo/ui/libs";

const useDownloadLoaderMutation = () => {
  return useMutation({
    mutationFn: downloadLoaderAPI,
    onError: handleNetworkError,
  });
};

export { useDownloadLoaderMutation };
